import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserListItemFragmentDoc } from '../../fragments/generated/UserListItem';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import { StaffRoleFragmentDoc } from '../../../../staff-roles/graphql/fragments/generated/StaffRole';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LearnersQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  filters?: Types.InputMaybe<Types.UsersFilters>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type LearnersQuery = { users: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { createdAt: string, status: Types.UserStatusEnum, isStaff: boolean, staffRoleIds?: Array<string> | null, uniqueId: string, id: string, name?: string | null, emailId?: string | null, profilePicture?: string | null, staffRoles?: Array<{ id: string, name: string, description?: string | null, type: Types.RoleTypesEnum, metadata?: { tagColor?: string | null, configuredPermissions?: Array<string> | null } | null }> | null, properties?: { syncedFromProvider?: { id: string, iconUrl: string, name: string } | null } | null, orgRole?: { id: string, name: string } | null } }> | null } };


export const LearnersDocument = /*#__PURE__*/ gql`
    query learners($sort: [SortType!], $filters: UsersFilters, $after: String, $first: Float) {
  users(filters: $filters, sort: $sort, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...UserListItem
      }
    }
  }
}
    ${UserListItemFragmentDoc}
${UserFragmentDoc}
${StaffRoleFragmentDoc}`;

export function useLearnersQuery(options?: Omit<Urql.UseQueryArgs<LearnersQueryVariables>, 'query'>) {
  return Urql.useQuery<LearnersQuery, LearnersQueryVariables>({ query: LearnersDocument, ...options });
};